import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Button, Row, Col, Typography, message, Popconfirm } from "antd";
import { platformApi } from "../../../../api";
import VehicleName from "../../../VehicleName";

const { Text, Title } = Typography;
const { TextArea } = Input;

const FeedbackModal = (props) => {
  const { visible, onCancel, saleRegister, onSaveSuccess } = props;
  const [feedback, setFeedback] = useState("");
  const [editable, setEditable] = useState(false);

  useEffect(() => {
    if (saleRegister) {
      setFeedback(saleRegister.customerFeedback || "");
      setEditable(false);
    }
  }, [saleRegister, visible]);

  // === Save feedback ===
  const handleSave = () => {
    if (!saleRegister || !saleRegister.id) return;
    platformApi
      .post("/api/saleRegister/saveFeedback", {
        id: saleRegister.id,
        customerFeedback: feedback,
      })
      .then((res) => {
        if (res.data.code === 200) {
          message.success("Feedback updated successfully");
          setEditable(false);
          if (onSaveSuccess) onSaveSuccess();
        } else {
          message.error("Unable to update feedback");
        }
      })
      .catch((err) => {
        message.error("Error updating feedback");
      });
  };

  // === Delete feedback ===
  const handleDelete = () => {
    if (!saleRegister || !saleRegister.id) return;
    platformApi
      .delete(`/api/saleRegister/deleteFeedback/${saleRegister.id}`)
      .then((res) => {
        if (res.data.code === 200) {
          message.success("Feedback deleted successfully");
          setFeedback("");
          setEditable(false);
          if (onSaveSuccess) onSaveSuccess();
        } else {
          message.error("Unable to delete feedback");
        }
      })
      .catch((err) => {
        message.error("Error deleting feedback");
      });
  };

  return (
    <Modal
      title="Customer Feedback"
      visible={visible}
      onCancel={onCancel}
      width={600}
      footer={[
        feedback ? (
          <Popconfirm
            key="delete"
            title="Are you sure you want to delete this feedback?"
            onConfirm={handleDelete}
            okText="Yes"
            cancelText="No"
          >
            <Button disabled={!editable} danger>
              Delete
            </Button>
          </Popconfirm>
        ) : null,
        !editable ? (
          <Button
            key="modify"
            type="primary"
            onClick={() => setEditable(true)}
            style={{ marginLeft: 8 }}   // 👈 space from the previous button
          >
            Modify
          </Button>
        ) : (
          <Button
            key="save"
            type="primary"
            onClick={handleSave}
            style={{ marginLeft: 8 }}
          >
            Save
          </Button>
        ),
      ]}
    >
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Text strong>Customer Name: </Text>
          <Text>{(saleRegister && saleRegister.saleData && saleRegister.saleData.customerName) || "-"}</Text>
        </Col>
        <Col span={12}>
          <Text strong>Vehicle: </Text>
          <Text>
            <VehicleName
              nameOnly
              value={saleRegister?.saleData?.vehicle}
              fallback="-"
            />
          </Text>
        </Col>
        <Col span={12}>
          <Text strong>Sale ID: </Text>
          <Text>{(saleRegister && saleRegister.saleId) || "-"}</Text>
        </Col>
        <Col span={12}>
          <Text strong>Chassis No: </Text>
          <Text>{(saleRegister && saleRegister.chassisNumber) || "-"}</Text>
        </Col>
        <Col span={24} style={{ marginTop: "16px" }}>
          <Text strong>Feedback</Text>
          <TextArea
            rows={4}
            value={feedback}
            disabled={!editable}
            onChange={(e) => setFeedback(e.target.value)}
            style={{ marginTop: "8px" }}
          />
        </Col>
      </Row>
    </Modal>
  );
};

export default FeedbackModal;
